<template>
    <div class="pt-10">
        <AtomSubFolderTitleOpaque :title="subFolder.title"></AtomSubFolderTitleOpaque>
        <section class="p-3 pt-6 lg:p-12">
            <div class="flex flex-col gap-28 lg:flex-row lg:gap-0 mb-40">
                <div class="relative lg:w-[50%]">
                    <p class="lg:uppercase">{{ subFolder.subtitle }}</p>
                    <div v-if="subFolder.public_image_path" class="flex items-center h-full">
                        <img class="mt-16 object-cover h-[200px] w-[300px] lg:h-[300px] lg:w-[400px]" :src="subFolder.public_image_path" alt="">
                    </div>
                </div>

                <div class="self-end w-2/3 lg:w-[50%] lg:self-start">
                    <p class="lg:text-xl" v-html="subFolder.description"></p>
                </div>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 lg:gap-6">
                <MoleculeItemCard v-for="item in subFolder.items" :item="item" :key="`item-${item.id}`" />
            </div>

            <div class="pb-32">
                <a :href="subFolder.link">
                    <AtomButtonArrowRight style="pointer-events: none">
                        {{ $t('folder.viewAllWorks') }}
                    </AtomButtonArrowRight>
                </a>
            </div>
        </section>
    </div>
</template>

<script>
import MoleculeItemCard from "../../global/molecules/MoleculeItemCard.vue";
import AtomSubFolderTitleOpaque from "../atoms/AtomSubFolderTitleOpaque.vue";
import AtomButtonArrowRight from "../../global/atoms/AtomButtonArrowRight.vue";

export default {
    name: 'OrganismFolderSubFolder',
    components: {AtomButtonArrowRight, AtomSubFolderTitleOpaque, MoleculeItemCard},
    props: {
        subFolder: {
            required: true,
            type: Object
        }
    }
}
</script>
